import { useAuthBootstrap } from "~/composables/useAuthBootstrap";

export default defineNuxtPlugin(() => {
  const { hydrateFromSession } = useAuthBootstrap();
  hydrateFromSession();
});
